// extracted by mini-css-extract-plugin
export default {"card--selected":"components-hotel-reviews-review-card-module__card--selected","badge-pending":"components-hotel-reviews-review-card-module__badge-pending"};